export default __webpack_public_path__ + "maps-examples-annotation-views-1200-46e42efc09b210eae69b122156c3665b.png";